import { Bar, BarChart, CartesianGrid, Legend, XAxis, YAxis } from 'recharts';
import { StackedBarShape } from '../../components/SharedComponents/StackedBarShape';
import type { CustomerAnalyticsMoodysReportDto } from '@zg-rentals/ts-customer-analytics-client';
import { Label } from 'recharts';
import { renderChartToPdf, sortReportByQuarter } from './pdfImageUtils';

interface InventoryChartProps {
  report: CustomerAnalyticsMoodysReportDto;
  showQuarterly: boolean;
}

const InventoryChart = ({ report, showQuarterly }: InventoryChartProps) => {
  if (!report.inventoryReport) return null;
  const data = report.inventoryReport
    .filter((row) => (showQuarterly ? row.quarter !== 'Y' : row.quarter === 'Y'))
    .sort((a, b) => sortReportByQuarter(a.year, b.year, a.quarter, b.quarter))
    .map((item) => ({
      name: item.quarter === 'Y' ? item.year : `${item.quarter} ${item.year}`,
      occupied: item.occupiedStockInUnits,
      vacant: item.vacantStockInUnits,
      inventory: item.inventoryPerUnit,
    }));

  return (
    <BarChart
      width={1400}
      height={500}
      data={data}
      margin={{
        top: 10,
        right: 5,
        left: 22,
        bottom: 30,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis tickFormatter={(value: number) => value.toLocaleString()}>
        <Label
          value="Inventory"
          offset={-12}
          angle={-90}
          position="insideLeft"
          style={{ textAnchor: 'middle', fontSize: '30px' }}
        />
      </YAxis>
      <Legend wrapperStyle={{ position: 'relative', fontSize: '30px', marginTop: '-15px' }} />
      <Bar
        barSize={20}
        stackId="a"
        isAnimationActive={false}
        dataKey="occupied"
        fill="#001851"
        name="Occupied Stock"
        shape={StackedBarShape}
      />
      <Bar
        barSize={20}
        stackId="a"
        isAnimationActive={false}
        dataKey="vacant"
        fill="#b7b7b7"
        name="Vacant Stock"
        shape={StackedBarShape}
      />
    </BarChart>
  );
};

export const renderInventoryChart = async (
  report: CustomerAnalyticsMoodysReportDto,
  showQuarterly: boolean,
): Promise<string> => {
  return await renderChartToPdf(<InventoryChart report={report} showQuarterly={showQuarterly} />);
};
